import styled from "styled-components";

export const RadioLabelContainer = styled.div<{
  iconPosition?: "left" | "right";
}>`
  display: flex;
  flex-direction: ${({ iconPosition }) =>
    iconPosition === "right" ? "row-reverse" : "row"};
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 7px 0;
`;
